import React from "react";
import { Modal } from "antd";

const AddeditclientModal = ({ isaddModalOpen, setIsaddModalOpen }) => {
  const handleOk = () => {
    setIsaddModalOpen(false);
  };
  const handleCancel = () => {
    setIsaddModalOpen(false);
  };
  return (
    <>
      <Modal
        open={isaddModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className=" addeditclientmodal"
        centered={true}
        width="80%"
      >
        <div className="modal-content my-5">
          <h2 className="fw-bold text-medium-black text-center ">
            Add/Edit Client
          </h2>
          <form>
            <div className="template-div v-center h-center flex-column mt-5">
              <div className="edit-profile-main d-flex flex-column gap-5">
                <div className="edit-container d-flex space-between gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>Client Name</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input mt-2"
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>Email Address</h5>
                    <input
                      type="email"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>Address</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                </div>
                <div className="edit-container d-flex space-between ">
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>Phone No.</h5>
                    <input
                      type="number"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>Country</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>State</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                </div>
                <div className="edit-container d-flex space-between ">
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>District</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column">
                    <h5>ZIP</h5>
                    <input
                      type="number"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column">
                    <h5>City</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                </div>
                <div className="edit-container d-flex gap-5 ">
                  <div className="edit-profile-inner d-flex flex-column ">
                    <h5>Contact Name</h5>
                    <input
                      type="text"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                  <div className="edit-profile-inner d-flex flex-column">
                    <h5>Contact Phone Number</h5>
                    <input
                      type="number"
                      placeholder="Type..."
                      className="modal-input  mt-2"
                    ></input>
                  </div>
                </div>
              </div>

              <div className="modal-bottom-btns h-center gap-2 mt-5">
                <button className="modal-dark-btn" onClick={handleCancel}>
                  Close
                </button>
                <button className="modal-dark-btn" onClick={handleOk}>
                  Save
                </button>
                <button className="modal-trans-btn">Reset</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddeditclientModal;
